<script setup lang="ts">
import { computed } from 'vue';

import { OrderDetailsPayload, PaymentInfo } from '@/utils/orderDetails';

const props = defineProps<{
  order: OrderDetailsPayload;
  paymentInfo: PaymentInfo;
}>();

const emit = defineEmits(['edit-billing']);

const isDeclined = computed(
  () => props.order.status_description === 'Authorization Declined' && props.order.status_message,
);

const openEditBillingModal = () => emit('edit-billing');
</script>

<template>
  <div>
    <h3 class="text-lg">Payment Details:</h3>
    <p v-if="paymentInfo.type" class="mt-5"><b>Payment method:</b> {{ paymentInfo.type }}<br /></p>
    <p v-if="paymentInfo.externalAccountToken" class="truncate whitespace-normal">
      <b>Email:</b>
      {{ paymentInfo.externalAccountToken }}<br />
    </p>
    <p
      v-if="paymentInfo.description && paymentInfo.type && paymentInfo.type !== 'Apple Pay'"
      class="truncate whitespace-normal"
    >
      <b>Card:</b>
      {{ paymentInfo.description }}<br />
    </p>
    <p
      v-if="
        paymentInfo.expiration &&
        paymentInfo.type &&
        !['Apple Pay', 'PayPal'].includes(paymentInfo.type)
      "
    >
      <b>Exp:</b> {{ paymentInfo.expiration }}
      <br />
    </p>
    <p v-if="order.status">
      <b>Status: </b>
      <span
        class="order-status"
        :class="`${order.status_description} ${order.status_message ? 'error' : ''}`"
      >
        <span v-if="isDeclined">Declined</span>
        <span v-else>
          {{ order.status }}
        </span>
      </span>
      <a
        v-if="isDeclined"
        class="p-0 mt-3 ml-1 bg-transparent border-0 appearance-none cursor-pointer w-min"
        type="button"
        @click="openEditBillingModal"
      >
        <span class="mt-2 text-base leading-5 underline font-proxima-nova">Update Payment</span>
      </a>
      <br />
    </p>
  </div>
</template>

<style lang="scss" scoped>
p {
  @apply mb-0;
}

.order-status {
  @apply text-amber-700;

  &.Authorization.Declined.error {
    @apply text-nuts-red-800;
  }
}
</style>
